import type { MiniSplashProps } from './types';
import { cls } from '@/utils/cls';
import style from './MiniSplash.module.scss';
function MiniSplash({
  extendStyles,
  backgroundImage,
  mobileBackgroundImage,
  backgroundColor = 'transparent',
  height = 200,
  mobileHeight = 200,
  shouldContain = false
}: MiniSplashProps) {
  const _className = cls(style.root, shouldContain && style.contain, extendStyles);
  return <>
			<section className={cls(_className, style.desktop)} style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundColor,
      height: `${height}px`
    }} />
			<section className={cls(_className, style.mobile)} style={{
      backgroundImage: `url(${mobileBackgroundImage ? mobileBackgroundImage : backgroundImage})`,
      backgroundColor,
      height: `${mobileHeight ? mobileHeight : height}px`
    }} />
		</>;
}
export default MiniSplash;